import BrandConfigStore from '@/context/store/brand-config';
import { useTranslation } from 'react-i18next';

const Faq = () => {
	const { t } = useTranslation();
	const { /* backgroundColor, */ colors } = BrandConfigStore(
		(state) => state.config.themeConfig.container
	);
	const config = BrandConfigStore((state) => state.config);
	const url = config.websiteUrl.split('://')[1];
	const brand = config.brandName;

	const faqList = [
		{
			id: 1,
			q: t('text.faq.q1'),
			a: (
				<p>
					<span>{t('text.faq.a1a')}</span>{' '}
					<a className="underline" target="_blank" rel="noreferrer" href={config.websiteUrl}>
						{url}
					</a>{' '}
					{t('text.faq.a1b')}
				</p>
			),
			c: []
		},
		{
			id: 2,
			q: t('text.faq.q2'),
			a: t('text.faq.a2'),
			c: []
		},
		{
			id: 3,
			q: t('text.faq.q3'),
			a: (
				<p>
					<span>{t('text.faq.a3a')}</span>{' '}
					<a className="underline" target="_blank" rel="noreferrer" href={config.websiteUrl}>
						{url}
					</a>{' '}
					{t('text.faq.a3b')}
				</p>
			),
			c: []
		},
		{
			id: 4,
			q: t('text.faq.q4'),
			a: (
				<p>
					<span>{t('text.faq.a4a')}</span>{' '}
					<a className="underline" target="_blank" rel="noreferrer" href={config.websiteUrl}>
						{url}
					</a>{' '}
					{t('text.faq.a4b')}
				</p>
			),
			c: []
		},
		{
			id: 5,
			q: t('text.faq.q5'),
			a: (
				<div className="space-y-2">
					<p>{t('text.faq.a5')}</p>
					<p>{t('text.faq.a5a')}</p>
				</div>
			),
			c: [
				{
					m: t('text.faq.a5.method'),
					d: t('text.faq.a5.methodDetails')
				},
				{
					m: t('text.faq.a5a.method'),
					d: t('text.faq.a5a.methodDetails')
				},
				{
					m: t('text.faq.a5b.method'),
					d: (
						<div className="space-y-2">
							<p>{t('text.faq.a5b1.methodDetails')}</p>
							<p>
								{t('text.faq.a5b2.methodDetails')} {brand} {t('text.faq.a5b2a.methodDetails')}
							</p>
							<p>{t('text.faq.a5b2b.methodDetails')}</p>
							<p>{`${t('text.faq.a5b2c.methodDetails')} ${brand}${t(
								'text.faq.a5b2c1.methodDetails'
							)}`}</p>
						</div>
					)
				}
			]
		},
		{
			id: 6,
			q: t('text.faq.q6'),
			a: t('text.faq.a6'),
			c: []
		},
		{
			id: 7,
			q: t('text.faq.q7'),
			a: (
				<p>
					<span>{t('text.faq.a7')}</span>{' '}
					<a
						className="underline"
						rel="noreferrer"
						target="_blank"
						href="https://www.blockchain.com">
						www.blockchain.com
					</a>{' '}
					<span>{t('text.faq.a7a')}</span>
				</p>
			),
			c: []
		},
		{
			id: 8,
			q: t('text.faq.q8'),
			a: t('text.faq.a8'),
			c: []
		},
		{
			id: 9,
			q: t('text.faq.q9'),
			a: t('text.faq.a9'),
			c: []
		},
		{
			id: 10,
			q: t('text.faq.q10'),
			a: t('text.faq.a10'),
			c: []
		},
		{
			id: 11,
			q: `${t('text.faq.q11')} ${brand}?`,
			a: `${t('text.faq.a11')} ${brand}, ${t('text.faq.a11a')}`,
			c: []
		},
		{
			id: 12,
			q: `${t('text.faq.q12')} ${brand}?`,
			a: `${t('text.faq.a12')} ${brand}${t('text.faq.a12b')}`,
			c: []
		},
		{
			id: 13,
			q: t('text.faq.q13'),
			a: t('text.faq.a13'),
			c: []
		},
		{
			id: 14,
			q: t('text.faq.q14'),
			a: t('text.faq.a14'),
			c: []
		},
		{
			id: 15,
			q: t('text.faq.q15'),
			a: `${t('text.faq.a15')}, ${brand} ${t('text.faq.a15a')}`,
			c: []
		},
		{
			id: 16,
			q: t('text.faq.q16'),
			a: t('text.faq.a16'),
			c: []
		},
		{
			id: 17,
			q: t('text.faq.q17'),
			a: t('text.faq.a17'),
			c: []
		},
		{
			id: 18,
			q: t('text.faq.q18'),
			a: t('text.faq.a18'),
			c: []
		}
	];

	const cnr = [
		{
			id: 1,
			q: `${t('text.cnr.q1a')} ${brand} ${t('text.cnr.q1b')}`,
			a: (
				<p>
					<span>{t('text.cnr.a1a')}</span>{' '}
					<a className="underline" target="_blank" rel="noreferrer" href={config.websiteUrl}>
						{url}
					</a>{' '}
					{t('text.cnr.a1b')}
				</p>
			)
		},
		{
			id: 2,
			q: t('text.cnr.q2'),
			a: (
				<p>
					<a className="underline" target="_blank" rel="noreferrer" href={config.websiteUrl}>
						{url}
					</a>{' '}
					{t('text.cnr.a2')}
				</p>
			)
		},
		{
			id: 3,
			q: t('text.cnr.q3'),
			a: t('text.cnr.a3')
		},
		{
			id: 4,
			q: t('text.cnr.q4'),
			a: t('text.cnr.a4')
		}
	];

	return (
		<>
			<div className="mx-auto">
				<div className="p-10 space-y-3">
					<div className="text-center text-3xl font-bold text-container-color-primary">
						{t('text.faq.title')}
					</div>
					{faqList.map((faq, index) => (
						<div key={`${index}` + faq.id}>
							<div className="flex gap-2 font-bold" style={{ color: colors.secondary }}>
								<p>Q:</p>
								<div>{faq.q}</div>
							</div>
							<div className="flex gap-2 text-container-color-primary">
								<p>A: </p>
								<div>{faq.a}</div>
							</div>
							{faq.c.length ? (
								<div className=" pl-6 pt-3 space-y-2 text-container-color-primary">
									{faq.c.map((c) => (
										<div key={c.m}>
											<div className="underline">{c.m}</div>
											<div>{c.d}</div>
										</div>
									))}
								</div>
							) : null}
						</div>
					))}
					<div className="text-center text-3xl font-bold pt-10 text-container-color-primary">
						{t('text.faq.title2')}
					</div>
					{cnr.map((el) => (
						<div key={el.id}>
							<div className="flex gap-2 font-bold" style={{ color: colors.secondary }}>
								<p>Q:</p>
								<div>{el.q}</div>
							</div>
							<div className="flex gap-2 text-container-color-primary">
								<p>A: </p>
								<div>{el.a}</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</>
	);
};

export default Faq;
